@if (isIdle() || isRecording() || isDenied()) {
<div class="flex items-center justify-between">
  <p class="recording-text">
    @if (isIdle()) {
    You can create your story via voice message
    }
    @if (isRecording()) {
    Recording...
    }
    @if(isDenied()) {
    Denied. Change your settings.
    }
  </p>

  <div class="rounded-full w-12 h-12 cursor-pointer flex items-center justify-center" aria-hidden="true"
    (click)="onIconClick()" [class]="isDenied() ? 'bg-orange-100' : 'bg-blue-50'">
    <div class="rounded-full w-9 h-9 text-blue flex items-center justify-center"
      [class]="isDenied() ? 'bg-orange-300' : 'bg-blue-300'" aria-hidden="true">
      @if (isIdle()) {
      <app-icon name="heroMicrophoneSolid" class="text-blue" size="medium"></app-icon>
      }
      @if (isRecording()) {
      <app-icon name="heroStopSolid" size="medium"></app-icon>
      }
      @if(isDenied()) {
      <app-icon class="text-white" name="heroCog8ToothSolid" size="medium"></app-icon>
      }
    </div>
  </div>
</div>
}

@if (isRecorded()) {
<div class="flex justify-between items-center">
  <div class="icon bg-blue-light rounded-full shadow-xl w-9 h-9 flex items-center justify-center cursor-pointer"
    (click)="onIconClick()" aria-hidden="true">
    <app-icon [name]="isPlay() ? 'heroPauseSolid' : 'heroPlaySolid'" class="text-white" size="medium"></app-icon>
  </div>

  <div #waveform class="w-full waveform"></div>

  <div class="bg-gray text-white text-xs font-medium me-2 text-center py-0.5 w-12 rounded-full">{{formatTime( isPlay()
    || isPause() ?
    audioCurrentTime : recordingTime )}}
  </div>

  @if(!isPreviewMode() || isEditMode()) {
  <app-icon name="heroTrash" size="medium" class="text-yellow cursor-pointer" (click)="onRemove()"></app-icon>
  }

  @if (audioUrlSignal()) {
  <audio [src]="audioUrlSignal()" class="hidden" controls></audio>
  }
</div>
}
